module.exports = __webpack_public_path__ + "static/media/banner-premio.8af1ec69.png";